import { BACKEND_URL } from "@/const";
import { Cloud, X } from "lucide-react";
import { apiFetch } from "@/utils/api";
import { observer } from "mobx-react-lite";
import { useState } from "react";

const CloudConfigModal = ({ onClose }: { onClose: () => void }) => {
  const [jsonContent, setJsonContent] = useState('');
  const [status, setStatus] = useState('');

  const handleSave = async () => {
    try {
      // Validate JSON
      JSON.parse(jsonContent);

      const res = await apiFetch(`/api/cloud/config`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ credentials: jsonContent })
      });
      if (res.ok) {
        setStatus('Gespeichert! Google Drive Verbindung aktiv.');
        setTimeout(onClose, 2000);
      } else {
        setStatus('Fehler beim Speichern.');
      }
    } catch (e) {
      setStatus('Ungültiges JSON Format.');
    }
  };

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-[70] p-4">
      <div className="bg-surface-2 rounded-2xl border border-blue-500/30 p-6 w-full max-w-lg shadow-2xl animate-in fade-in zoom-in-95 duration-200">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-blue-400 flex items-center"><Cloud size={24} className="mr-2" /> Google Drive Setup</h2>
          <button onClick={onClose} className="p-2 text-fg-muted hover:text-white hover:bg-surface-2 rounded-lg transition-all transform hover:scale-110 active:scale-95"><X size={24} /></button>
        </div>
        <p className="text-sm text-fg-muted mb-4">
          Bitte füge hier den Inhalt deiner <code>credentials.json</code> (Google Service Account Key) ein.
        </p>
        <textarea
          value={jsonContent}
          onChange={e => setJsonContent(e.target.value)}
          className="w-full h-48 bg-black/50 border border-line rounded p-3 text-xs font-mono text-green-400 outline-none focus:border-blue-500 mb-4"
          placeholder="{ 'type': 'service_account', ... }"
        />
        <div className="flex justify-between items-center">
          <span className={`text-sm ${status.includes('Fehler') || status.includes('Ungültig') ? 'text-red-400' : 'text-green-400'}`}>{status}</span>
          <button onClick={handleSave} className="bg-blue-600 hover:bg-blue-500 text-white font-bold py-2 px-6 rounded-lg transition-all transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-blue-500/25">
            Speichern & Verbinden
          </button>
        </div>
      </div>
    </div>
  );
};

export default observer(CloudConfigModal);